module.exports = __webpack_public_path__ + "img/chuku.d115dd0b.png";